import VuexPersistence from 'vuex-persist';

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})



const state = {
    openNodes: null
}

const getters = {
    open(state) {
        console.log('open(state) ' + JSON.stringify(state.openNodes));
        return state.openNodes;
    }
}

const mutations = {
    SET_OPEN_NODES(state, value) {
        console.log('SET_OPEN_NODES ' + JSON.stringify(value));
        state.openNodes = value
    }
}

const actions = {
    setOpenNodes({ commit}, payload) {
        commit('SET_OPEN_NODES', payload.openNodes)
    },
 }

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
    plugins: [vuexLocal.plugin]
}
